import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { GatewayCreateUserModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/users/models/inputs/gateway-create-user.model';
import { SubmitErrorHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { UserCreateFormStep1Controller } from '@app/feature/user/user-create/user-create-form-step-1/user-create-form-step-1.controller';
import { UserCreateFormStep2Controller } from '@app/feature/user/user-create/user-create-form-step-2/user-create-form-step-2.controller';
import { useCreateUserContext } from '@app/feature/user/user.context';

export interface UserCreateFormControllerProps {
  onError: SubmitErrorHandler<GatewayCreateUserModel>;
  onSubmit: SubmitHandlerWithDirtyFields<GatewayCreateUserModel>;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const UserCreateFormController = (
  props: UserCreateFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, state } = props;
  const { t } = useTranslation();
  const data = useCreateUserContext();

  return (
    <MultiStepFormProvider<GatewayCreateUserModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          title: t('$.user-create.step-1.title'),
          iconName: 'user-01',
          fields: [
            'lastName',
            'firstName',
            'emailAddress',
            'mobileNumber',
            'landlineNumber',
            'roleId',
          ],
          component: <UserCreateFormStep1Controller />,
        },
        {
          title: t('$.user-create.step-2.title'),
          iconName: 'server-06',
          fields: ['customerId'],
          component: <UserCreateFormStep2Controller />,
        },
      ]}
    />
  );
};
